var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-progress',{staticClass:"w-100 page-progress",attrs:{"value":_vm.current,"max":_vm.max,"variant":_vm.variant ? _vm.variant : 'secondary'}})}
var staticRenderFns = []

export { render, staticRenderFns }